import React, { useEffect, useState } from "react";
import api from "../../api";
import { useNavigate } from "react-router-dom";
import Navbar from "../Core/Navbar";
import Footer from "../Core/Footer";
import "../../Styles/Home.css"

function Wishlist() {
  const navigate = useNavigate();
  const accessToken = localStorage.getItem("accessToken");
  const [historyList, setHistoryList] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getHistoryList();
  }, []);

  const getHistoryList = async () => {
    setLoading(true);
    try {
      const response = await api.get(
        `user_api/order-history?access_token=${JSON.parse(accessToken)}`
      );

      if (response.data.status === "success") {
        const list = response.data.order_details;
        setHistoryList(list);
        console.log(response.data);
      }
    } catch (error) {
      console.error("Error fetching wishlist:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{width:"99%"}}>
      <div
        style={{
          justifyContent: "center",
          alignItems: "center",
          marginTop: 20,
          marginBottom: 20,
        }}
      >
        {loading ? (
          <div
            style={{
              height: "70vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              gap: "10px",
            }}
          >
            <div className="loader" style={{ fontSize: "24px" }}>
              Loading...
            </div>
          </div>
        ) : historyList?.length > 0 ? (
          <div
            className="product-grid"
            style={{
              display: "flex",
              gap: "1rem",
              flexWrap: "wrap",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {historyList.map((prod, i) => (
              <div
                key={i}
                className="product-card4"
                style={{
                 
                  boxSizing: "border-box",
                  flex: "0 0 20%",
                  position: "relative",
                  cursor: "pointer",
                }}
                onClick={() => navigate(`/orderDetails/${prod.tracking_no}`)}
              >
                <div
                  className="product-image-container"
                  style={{
                    paddingTop: "0px",
                    backgroundColor: "white",
                    width: "100%",
                    height: "100%",
                    zIndex: 0,
                    padding:"5px"
                  }}
                >
                  <img
                    src={prod.product_image}
                    alt={prod.product_name}
                    className="product-image"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                    }}
                  />
                </div>
                <div className="product-info" style={{ padding: "0px" }}>
                  <h3
                    style={{
                      margin: "5px 0",
                     
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      height: "60px",
                    }}
                  >
                    {prod.product_name}
                  </h3>
                  <p
                    className="product-price"
                    style={{
                      fontWeight: "bold",
                      color: "#e63946",
                    }}
                  >
                    AED {prod.price}
                  </p>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}>
            <div
              style={{
                margin: "auto",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                gap: "5px",
              }}
            >
              <img
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQzg30UJ6wuvzvWf3S-MNDRqyAugtDzdJW9Yw&s"
                width="200px"
                height="150px"
                alt="No Orders"
              />
              <h3>You have no previous orders</h3>
              <p>
                We have thousands of items available across our wide range of
                sellers. Start ordering today!
              </p>
              <button
                style={{
                  backgroundColor: "blueviolet",
                  border: "none",
                  borderRadius: "5px",
                  color: "white",
                  padding: "10px 20px",
                  cursor: "pointer",
                }}
                onClick={() => navigate("/")}
              >
                Start Shopping
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Wishlist;
